const buildDots = (
  originX: number,
  originY: number,
  cols: number,
  rows: number,
  spacing: number,
  radius: number,
  keyPrefix: string
) => {
  const items = [];
  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < cols; col++) {
      items.push(
        <circle
          key={`${keyPrefix}-${row}-${col}`}
          cx={originX + col * spacing}
          cy={originY + row * spacing}
          r={radius}
        />
      );
    }
  }
  return items;
};

const topRightDots = buildDots(1480, 40, 7, 4, 24, 2.4, 'tr');
const bottomLeftDots = buildDots(24, 726, 7, 4, 24, 2.4, 'bl');

const BackgroundBubblesIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1600 900"
    preserveAspectRatio="xMidYMid slice"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        id="edgeBlue"
        gradientUnits="userSpaceOnUse"
        x1="-60"
        y1="120"
        x2="560"
        y2="400"
      >
        <stop offset="0%" stopColor="#5C8CE8" stopOpacity="0.5" />
        <stop offset="55%" stopColor="#5C8CE8" stopOpacity="0.18" />
        <stop offset="100%" stopColor="#5C8CE8" stopOpacity="0" />
      </linearGradient>

      <linearGradient
        id="edgePink"
        gradientUnits="userSpaceOnUse"
        x1="280"
        y1="-70"
        x2="680"
        y2="240"
      >
        <stop offset="0%" stopColor="#D998DE" stopOpacity="0.6" />
        <stop offset="60%" stopColor="#D998DE" stopOpacity="0.2" />
        <stop offset="100%" stopColor="#D998DE" stopOpacity="0" />
      </linearGradient>

      <linearGradient
        id="edgeBlueBottom"
        gradientUnits="userSpaceOnUse"
        x1="-70"
        y1="900"
        x2="520"
        y2="640"
      >
        <stop offset="0%" stopColor="#5C8CE8" stopOpacity="0.48" />
        <stop offset="55%" stopColor="#5C8CE8" stopOpacity="0.16" />
        <stop offset="100%" stopColor="#5C8CE8" stopOpacity="0" />
      </linearGradient>

      <radialGradient
        id="cornerBlue"
        gradientUnits="userSpaceOnUse"
        cx="1650"
        cy="760"
        r="330"
      >
        <stop offset="0%" stopColor="#7FA6EE" stopOpacity="0.6" />
        <stop offset="100%" stopColor="#7FA6EE" stopOpacity="0" />
      </radialGradient>

      <filter id="softEdge" x="-40%" y="-40%" width="180%" height="180%">
        <feGaussianBlur stdDeviation="24" />
      </filter>
    </defs>

    {/* base clara */}
    <rect x="0" y="0" width="1600" height="900" fill="#F8F9FC" />

    {/* mancha azul + violeta arriba-izquierda */}
    <g filter="url(#softEdge)">
      <path
        d="M-120,-60 C180,-140 560,-90 700,110 C800,260 740,440 500,500 C260,560 -20,480 -140,300 C-220,170 -220,10 -120,-60 Z"
        fill="url(#edgeBlue)"
      />
      <path
        d="M120,-90 C360,-150 640,-90 720,70 C790,200 700,300 500,270 C300,240 140,150 90,20 C60,-50 70,-70 120,-90 Z"
        fill="url(#edgePink)"
      />
    </g>

    {/* mancha azul abajo-izquierda */}
    <g filter="url(#softEdge)">
      <path
        d="M-140,640 C80,570 380,590 520,720 C650,830 590,930 350,950 C100,970 -140,900 -190,760 C-220,680 -200,670 -140,640 Z"
        fill="url(#edgeBlueBottom)"
      />
    </g>

    {/* mancha azul esquina inferior derecha */}
    <ellipse cx="1650" cy="760" rx="280" ry="260" fill="url(#cornerBlue)" filter="url(#softEdge)" />

    {/* puntitos superior derecha */}
    <g fill="#7FA6EE" fillOpacity="0.5">
      {topRightDots}
    </g>

    {/* puntitos inferior izquierda */}
    <g fill="#4E7FDB" fillOpacity="0.55">
      {bottomLeftDots}
    </g>
  </svg>
);

export default BackgroundBubblesIcon;
